/**
 * @generated SignedSource<<18922a4def58ef7edde3ab353fd7f1bc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePageLiveArticleBodyContent$data = {
  readonly liveArticle: {
    readonly " $fragmentSpreads": FragmentRefs<"ssrLiveContentsPreviewLiveArticle">;
  } | null | undefined;
  readonly " $fragmentType": "articlePageLiveArticleBodyContent";
};
export type articlePageLiveArticleBodyContent$key = {
  readonly " $data"?: articlePageLiveArticleBodyContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePageLiveArticleBodyContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "entityUuid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePageLiveArticleBodyContent",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityUuid",
              "variableName": "entityUuid"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        }
      ],
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "liveArticle",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ssrLiveContentsPreviewLiveArticle"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "f2685093c783c3aa546ec878ecd55186";

export default node;
